export default "__VITE_ASSET__3f33e8f8__"